define.alias("checkout/components/checkout-button", "settings/components/checkout-button");